import React, { PropsWithChildren } from 'react';
import { gql } from '@yi/core';

import { graphql } from 'gatsby';

import { MeditationPage } from './MeditationPage';

export const Meditation: React.FC<PropsWithChildren<{ data: gql.typesSsr.Query_Meditation }>> = ({
  data,
}) => {
  const { yi } = data;
  if (!yi) return null;
  return <MeditationPage content={yi.Meditation} />;
};

export const query = graphql`
  query Query_Meditation($id: ID!) {
    yi {
      Meditation(id: $id) {
        __typename
        id
        title
        subtitle
        url_title
        full_url
        completed_count
        entry_date {
          iso8601
          yyyymmdd
        }
        no_text_image(params: { width: 1600, format: webp }) {
          processed_url
        }
        square_image(params: { width: 375, format: webp }) {
          processed_url
        }
        snippet(limit: 30000)
        short_summary
        seo_title
        seo_description
        parsed_body(params: { width: 800 })
        entry_type
        jwplayer_id
        brightcove_id
        language
        media_source
        media_download
        media_duration {
          iso8601
          group
          minutes
        }
        tags {
          id
          text
          url_title
        }
        teacher {
          id
          full_name
          url_title
          image(params: { width: 244, format: webp }) {
            processed_url
          }
          snippet
        }
        secondary_teacher {
          id
          full_name
          url_title
          image(params: { width: 244, format: webp }) {
            processed_url
          }
          snippet
        }
        next {
          localized_path
        }
        prev {
          localized_path
        }
        style {
          id
          name
        }
        focus {
          id
          name
        }
        practiceType
      }
    }
  }
`;

// eslint-disable-next-line import/no-default-export
export default Meditation;
